<template>
  <div>
    <!-- 결재레벨 & 결재선변경 -->
    <v-row class="ma-0">
      <v-col
        cols="12"
        class="condition-wrap btn-sign-wrap d-flex justify-space-between"
      >
        <v-btn
          elevation="0"
          text
          :ripple="false"
          class="btn-sign"
          height="42"
          :disabled="
            GET_UI_INFO.orgLevelYn == 'Y' && GET_APPL_SEQ_EXIST == 'N'
              ? false
              : true
          "
          @click="applLevelSheet = !applLevelSheet"
        >
          <span>{{ currApplLevelNm }}</span>
          <v-icon color="#9ca3ab" class="ml-1" size="24"
            >mdi-chevron-right</v-icon
          >
        </v-btn>
        <v-btn
          elevation="0"
          height="42"
          v-show="GET_APPL_SEQ_EXIST == 'N' && GET_UI_INFO.appPathYn == 'Y'"
          @click="openModal('change_approval_line')"
          class="btn-change"
        >
          <v-icon class="mr-1" size="18">mdi-pencil-outline</v-icon>
          결재선 변경
        </v-btn>
      </v-col>
    </v-row>
    <!---------------------------------------------------------------------------->
    <!-- 결재레벨 선택 -->
<!--    <bottom-select-->
<!--      :flag="applLevelSheet"-->
<!--      :list="GET_LEVEL_CODE_LIST"-->
<!--      :title="selecttitle"-->
<!--      @selectItem="changeApplLine"-->
<!--    ></bottom-select>-->
    <v-bottom-sheet v-if="applLevelSheet" v-model="applLevelSheet">
      <bottom-sheet :title="selecttitle" :default="selected" :items="GET_LEVEL_CODE_LIST" @selectItem="changeApplLine"></bottom-sheet>
    </v-bottom-sheet>
    <!-- [모달] 결재선변경 -->
    <change-approval-line-dialog
      :applUserListProps="applUserListProps"
    ></change-approval-line-dialog>
  </div>
</template>

<script>
/* 결재자 리스트 */
import ChangeApprovalLineDialog from '@/components/application/dialog/ChangeApprovalLineDialog.vue'; // 결재선변경 modal component
import BottomSelect from '@/components/application/form/BottomSelect.vue';

import { mapGetters } from 'vuex';
import BottomSheet from "@/components/application/form/BottomSheet.vue";

export default {
  data: () => ({
    applLevelSheet: false, // 결재레벨선택 화면플래그
    currApplLevelNm: '', // 현재결재레벨명
    applUserListProps: [],
    selecttitle: '결재',
    selected : ''
  }),

  computed: {
    ...mapGetters('ELA', [
      'GET_ORG_LEVEL',
      'GET_LEVEL_CODE_LIST',
      'GET_APPL_SEQ_EXIST',
      'GET_APPL_USER_LIST',
      'GET_ELA_APPL_PARAM',
      'GET_UI_INFO',
      'SET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
    ]),
    ...mapGetters(['GET_USER_DATA','GET_PARAMS']),
  },

  methods: {
    /* 모달호출 */
    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);

      if (modalNm == 'change_approval_line') {
        // 결재자리스트 copy 생성
        this.applUserListProps = [];
        this.GET_APPL_USER_LIST.forEach(item => {
          this.applUserListProps.push(item);
        });
      }
    },

    /* 결재선변경조회 */
    async changeApplLine(levelObj) {
    // 결재레벨선택화면닫기
      this.applLevelSheet = false;

      this.selected = levelObj.code;

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        lvlCode: levelObj.code, // 현재선택한 조직코드
        applSeqExist: 'N',
      };

      try {
        //let getApplUserList = this.GET_APPL_USER_LIST;
        await this.$store.dispatch('ELA/FETCH_APPL_LINE', params);
        //this.GET_APPL_USER_LIST = getApplUserList;
        this.$store.commit('ELA/SET_APPL_USER_LIST', this.GET_APPL_USER_LIST);

        //alert(JSON.stringify(this.GET_APPL_USER_LIST[0]));
        // 결재레벨명 세팅
        this.currApplLevelNm = levelObj.codeNm;
        // orgLvl 변경
        this.$store.commit('ELA/SET_ORG_LVL', levelObj.code);

        for (let i=0; i<this.GET_MGR_USER_LIST.length; i++) {
          this.GET_MGR_USER_LIST[i].agreeSeq = this.GET_APPL_USER_LIST.length + this.GET_MGR_USER_LIST.length + 1;
          this.GET_MGR_USER_LIST[i].pashSeq = levelObj.code;
        }
        this.mgrUserListProps = [];
        this.GET_MGR_USER_LIST.forEach(item => {
          this.mgrUserListProps.push(item);
        });



      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    let code;
    // 화면오픈시 선택된 결재레벨명 세팅
    let orgLv = this.GET_ORG_LEVEL;

    //출산전후휴가 , 출산전후휴가 (다태아) 결재시 1단계 상위결재로 셋팅
    //20260518 출산전후휴가(미숙아) 추가 92번
    if(this.GET_PARAMS.gntCd == '90' || this.GET_PARAMS.gntCd == '91'|| this.GET_PARAMS.gntCd == '92' || this.GET_PARAMS.gntCd == '170')
    {
      orgLv = 1;
    }

    this.GET_LEVEL_CODE_LIST.forEach(item => {
      if (item.code == orgLv) {
        this.currApplLevelNm = item.codeNm;
        code = item.code;
        
      }
    });

    

    const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: this.GET_ELA_APPL_PARAM.searchApplCd,
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        lvlCode: code, // 현재선택한 조직코드
        applSeqExist: 'N',
      };

      await this.$store.dispatch('ELA/FETCH_APPL_LINE', params);
      this.$store.commit('ELA/SET_APPL_USER_LIST', this.GET_APPL_USER_LIST);


    //alert(this.GET_APPL_SEQ_EXIST);
    //alert(this.GET_UI_INFO.appPathYn);
  },

  components: {
    BottomSheet,
    ChangeApprovalLineDialog,
    BottomSelect,
  },
};
</script>

<style></style>
